import { ComponentPropsWithoutRef } from 'react';

export const FireflyAnimated = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="500"
    height="501.5"
    viewBox="0 0 333 332"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="166.373"
      cy="166.057"
      rx="165.953"
      ry="165.477"
      transform="rotate(-17.151 166.373 166.057)"
      fill="url(#paint0_radial_233_2611)"
      fillOpacity="0.6"
    />
    <path
      filter="url(#fillPartial)"
      d="M184.345 177.664C183.27 170.755 181.113 164.06 177.953 157.823C174.841 151.783 170.803 146.268 165.986 141.477C159.686 135.115 152.043 130.241 143.617 127.214C143.669 128.952 143.795 130.688 143.995 132.42C144.664 138.372 146.215 144.191 148.597 149.686C151.057 155.371 154.304 160.681 158.242 165.462C162.127 170.182 171.27 177.045 180.238 181.673L178.209 185.607C170.863 182.632 162.759 180.923 158.108 180.977C154.09 180.969 150.085 181.438 146.178 182.375C144.274 182.863 142.402 183.472 140.575 184.199C138.777 184.937 137.025 185.784 135.33 186.734C134.462 187.22 133.615 187.75 132.787 188.297C134.116 189.209 135.496 190.046 136.92 190.802C140.928 192.928 145.24 194.423 149.703 195.234C154.305 196.058 159.003 196.196 163.645 195.643C168.377 195.062 172.991 193.751 177.322 191.756L181.229 192.376C181.306 197.951 181.139 203.252 181.479 208.593C181.614 211.185 181.903 213.767 182.345 216.324C182.431 216.792 182.528 217.249 182.635 217.689C182.87 217.297 183.108 216.867 183.325 216.436C184.485 214.13 185.508 211.758 186.389 209.332C188.259 204.341 189.824 199.117 191.525 193.837L196.516 194.624C196.439 200.422 195.65 206.19 194.166 211.796C193.416 214.715 192.406 217.559 191.147 220.297C190.445 221.836 189.582 223.297 188.573 224.655C187.915 225.531 187.142 226.315 186.275 226.985C185.646 227.461 184.949 227.84 184.208 228.11C183.976 228.182 183.75 228.252 183.544 228.315C183.338 228.379 183.008 228.415 182.737 228.456C181.588 228.6 180.422 228.412 179.377 227.914C179.138 227.799 178.895 227.671 178.663 227.531C178.463 227.405 178.271 227.268 178.086 227.121C177.466 226.631 176.924 226.051 176.478 225.399C175.869 224.494 175.387 223.51 175.045 222.475C174.527 220.87 174.178 219.216 174.002 217.539C173.695 214.55 173.657 211.54 173.887 208.544C174.14 205.142 174.664 201.766 175.454 198.448C172.16 200.194 168.685 201.576 165.092 202.569C159.805 204.015 154.334 204.667 148.856 204.504C143.248 204.334 137.699 203.3 132.407 201.437C127.065 199.522 122.02 196.864 117.42 193.541L109.549 187.921L117.559 182.751C119.6 181.405 121.71 180.164 123.879 179.034C130.366 175.657 137.466 173.616 144.757 173.034C147.761 172.816 150.778 172.831 153.78 173.078C153.209 172.643 152.648 172.191 152.1 171.735C146.568 167.135 141.71 161.781 137.666 155.83C133.511 149.721 130.278 143.032 128.072 135.981C125.855 128.818 124.604 121.391 124.354 113.897L123.786 99.7335L137.024 104.65C144.809 107.368 152.152 111.214 158.82 116.065C165.38 120.873 171.112 126.717 175.794 133.367C180.381 139.81 183.93 146.931 186.313 154.472C187.08 156.972 187.677 159.521 188.1 162.101C188.407 161.279 188.733 160.451 189.089 159.672C190.288 156.847 191.659 154.098 193.194 151.44C193.596 150.763 193.985 150.091 194.446 149.418C194.907 148.744 195.318 148.072 195.843 147.394L196.599 146.382L197.497 145.378C198.162 144.628 198.886 143.931 199.66 143.293L205.833 152.011C197.783 157.404 192.09 166.381 189.165 177.755L184.345 177.664Z"
      fill="currentColor"
    />
    <defs>
      <radialGradient
        id="paint0_radial_233_2611"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(166.373 166.057) rotate(90) scale(165.477 176.138)"
      >
        <stop
          stopColor="#F7FC1F"
          stopOpacity="0.68"
        />
        <stop
          offset="1"
          stopColor="#2E193E"
          stopOpacity="0"
        />
      </radialGradient>
      <filter
        id="fillPartial"
        primitiveUnits="objectBoundingBox"
        x="0%"
        y="0%"
        width="100%"
        height="100%"
      >
        <feFlood
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          floodColor={props.floodColor}
        />
        <feOffset dy="0">
          <animate
            attributeName="dy"
            values="1; 0.7; 0.4; 0"
            dur="4s"
            keySplines="0 0.54 1 0.52; 0 0.54 1 0.52; 0 0.54 1 0.52; 0 0.54 1 0.52;"
            keyTimes="0; 0.3; 0.9; 1"
          />
        </feOffset>
        <feComposite
          operator="in"
          in2="SourceGraphic"
        />
        <feComposite
          operator="over"
          in2="SourceGraphic"
        />
      </filter>
    </defs>
  </svg>
);
